import { render, staticRenderFns } from "./ContinuousScrolling.vue?vue&type=template&id=3b8daf54&scoped=true&"
import script from "./ContinuousScrolling.vue?vue&type=script&lang=ts&"
export * from "./ContinuousScrolling.vue?vue&type=script&lang=ts&"
import style0 from "./ContinuousScrolling.vue?vue&type=style&index=0&id=3b8daf54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8daf54",
  null
  
)

export default component.exports